import { render } from "./Modal_Edit.vue?vue&type=template&id=6ec5660d"
import script from "./Modal_Edit.vue?vue&type=script&lang=js"
export * from "./Modal_Edit.vue?vue&type=script&lang=js"

import "./Modal_Edit.vue?vue&type=style&index=0&id=6ec5660d&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__